import { Check, Minus } from "lucide-react";

const COLS = ["ConsciousLearn", "Time4Learning", "IXL", "Khan Academy", "Outschool"];
const ROWS = [
  ["Price (1 learner)", "$19/mo", "$39.95/mo", "$19.95/mo (core 4)", "Free + Khanmigo $4/mo", "$10-25 per class"],
  ["Family of 4", "$39/mo", "~$128/mo", "~$32/mo", "Free + $4/mo", "Per class, per child"],
  ["All core K-12 subjects", 1, 1, 1, 1, 0],
  ["Mindful, self-discovery lessons", 1, 0, 0, 0, 0],
  ["Personal AI buddy with voice", 1, 0, 0, "AI tutor", 0],
  ["Live small-group classes", 1, 0, 0, 0, 1],
  ["GA / FL / AL standards editions", 1, 0, "State-aligned", 0, 0],
  ["Transcripts & homeschool records", 1, 1, 0, 0, 0],
  ["GED & business pathway", 1, 0, 0, 0, 0],
];

const Cell = ({ v, hl }) => (
  <td className={`px-4 py-3 text-sm ${hl ? "bg-[#2C4A3E]/5 font-medium text-[#2C4A3E]" : "text-stone-600"}`}>
    {v === 1 ? <Check className="w-4 h-4 text-[#6B9080]" /> : v === 0 ? <Minus className="w-4 h-4 text-stone-300" /> : v}
  </td>
);

export const PriceComparison = () => (
  <div className="mt-16" data-testid="price-comparison">
    <h3 className="font-display text-2xl text-[#2C4A3E]">How we compare</h3>
    <p className="text-stone-500 text-sm mt-1">Public list prices, checked June 2026. Competitor prices may change.</p>
    <div className="mt-6 overflow-x-auto rounded-3xl border border-[#E6DEC3] bg-white/70">
      <table className="w-full min-w-[760px] text-left">
        <thead><tr className="border-b border-[#E6DEC3]">
          <th className="px-4 py-3 text-xs uppercase tracking-widest text-stone-500" />
          {COLS.map((c, i) => <th key={c} className={`px-4 py-3 font-display text-base ${i === 0 ? "text-[#C87D53] bg-[#2C4A3E]/5" : "text-[#2C4A3E]"}`}>{c}</th>)}
        </tr></thead>
        <tbody>{ROWS.map(([label, ...vals]) => (
          <tr key={label} className="border-b border-[#E6DEC3]/60 last:border-0" data-testid={`compare-row-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <td className="px-4 py-3 text-sm text-stone-800">{label}</td>
            {vals.map((v, i) => <Cell key={i} v={v} hl={i === 0} />)}
          </tr>
        ))}</tbody>
      </table>
    </div>
  </div>
);
